import moment from 'moment';
import { initGrid } from 'utils/grid/grid';
import template from './user-activity-reports.html';
import eventDetailsDialog from './user-activity-reports-event-details-dialog.html';
import { fetchUserActivityReports, downloadActivityReports } from '../../actions/admin-reports.actions';

const RETAILER_NUMBER_REGEXP = /^[0-9]{1,9}$/;

const mapStateToThis = ({ ui, session, adminReports, config }) => {
  const { pagination } = ui;
  const { serverTime, locale } = session;
  const { items, isLoading } = adminReports;
  const { directionKey, sortColumnKey } = config;

  return {
    pagination,
    items,
    isLoading,
    serverTime,
    locale,
    directionKey,
    sortColumnKey,
  };
};

const mapDispatchToThis = {
  fetchUserActivityReports,
  downloadActivityReports,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$scope', 'gettextCatalog', 'Notifications')
class UserActivityReportsController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    this.initializeConfiguration();
    this.reportStatuses = this.getReportStatuses();
    this.headers = this.getHeaders();
    this.defaultParams = {
      [this.sortColumnKey]: 'eventDate',
      [this.directionKey]: false,
    };
    this.gridModel = initGrid(this.fetchUserActivityReports, this.defaultParams);
    this.clearFilter();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  initializeConfiguration() {
    this.exportData = [
      {
        label: 'CSV',
        extension: 'csv',
      },
    ];
  }

  getHeaders() {
    return [
      {
        text: this.gettextCatalog.getString('Name'),
        field: 'userFullName',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Email'),
        field: 'userName',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('User Class'),
        field: 'userRole',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Retailer No.'),
        field: 'retailerId',
        sortable: true,
      },
      {
        text: this.gettextCatalog.getString('Event Type'),
        field: 'eventType',
        sortable: false,
      },
      {
        text: this.gettextCatalog.getString('IP Address'),
        field: 'networkIp',
        sortable: false,
      },
      {
        text: this.gettextCatalog.getString('Event Result'),
        field: 'eventResult',
        sortable: false,
      },
      {
        text: this.gettextCatalog.getString('Date/Time'),
        field: 'eventDate',
        sortable: true,
        textAlignment: 'text-right',
      },
    ];
  }

  initializeFilters() {
    this.error = false;
    this.gridModel.pagingModel.filters = {
      fromDate: moment.unix(this.serverTime).startOf('week').valueOf(),
      toDate: moment.unix(this.serverTime).endOf('week').valueOf(),
    };
    this.$scope.$broadcast('resetUserActivityReportsFilter');
  }

  clearFilter() {
    this.initializeFilters();
    this.$scope.$broadcast('clearFilterUserActivityLog');
    this.search();
  }

  downloadReport(extension) {
    return this.downloadActivityReports(
      extension,
      {
        ...this.gridModel.pagingModel,
        pageSize: 0,
      } // Forces BE to export the entire data set
    );
  }

  async search() {
    if (this.gridModel.pagingModel.filters.retailerId && !RETAILER_NUMBER_REGEXP.test(this.gridModel.pagingModel.filters.retailerId)) {
      this.Notifications.alertWarning(this.gettextCatalog.getString('Retailer No. invalid format'));
      return;
    }
    if (!this.error) {
      await this.gridModel.applyFilters();
    }
  }

  showEventDetails(reportData) {
    return this.Notifications.showComplexDialog({
      template: eventDetailsDialog,
      resolve: {
        reportData: () => reportData,
        locale: () => this.locale,
      },
    });
  }

  getReportStatuses() {
    return {
      SUCCESS: this.gettextCatalog.getString('Success'),
      FAILURE: this.gettextCatalog.getString('Failed'),
    };
  }
}

export default class UserActivityReportsComponent {
  constructor() {
    this.template = template;
    this.controller = UserActivityReportsController;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/admin-reports/components/user-activity-reports/user-activity-reports-component.js